import { render, staticRenderFns } from "./administrationTrainingModule.vue?vue&type=template&id=398fcd00&"
import script from "./administrationTrainingModule.vue?vue&type=script&lang=js&"
export * from "./administrationTrainingModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports